export const PAGE_NAVIGATE = 'PAGE_NAVIGATE';

export const navigatePage = () => ({
  type: PAGE_NAVIGATE
});